<mat-card
  *ngIf="viewState === 'course'"
  [class.folder-tile]="true"
  [class.is_mouse_over]="isMouseOver" [class.last-child]="(((idx+1) % 3) === 0) ? true : false "
  (mouseover)="isMouseOver=true" (mouseout)="isMouseOver=false">
  <section style="width:100%; margin-top:0px; text-align: center;" *ngIf="this.isTrainerLogin">
    <img src="{{listItem.picture_preview}}" class="tile-listing-image" alt="" />
    <mat-icon class="article-link-icon folder-edit-icon"
              (click)="editFolder($event)"
              color="accent"
              matTooltip="Share course to the users">edit</mat-icon>
   <mat-icon class="article-link-icon"
              (click)="openCourseShares($event)"
              color="accent"
              matTooltip="Share course to the users">group</mat-icon>
  </section>
  <h1 class="tile-header text-center">{{listItem.name}}</h1>
  <section style="width:100%; margin-top:0px; text-align: center;">
    <button mat-raised-button color="accent" style="width: 100%;">Open Course</button>
  </section>
  <div class="tile-hint text-center">{{listItem.size}} Articles</div>
</mat-card>

<mat-card
  *ngIf="viewState === 'article'"
  [class.article-tile]="true"
  [class.is_mouse_over]="isMouseOver"
  [class.last-child]="(((idx+1) % 3) === 0) ? true : false "
  [class.float-layout-fix]="(((idx+1) % 3) === 1) ? true : false "
  (mouseover)="isMouseOver=true" (mouseout)="isMouseOver=false">
  <section style="width:100%; margin-top:0px; text-align: center; position: relative;">
    <mat-icon class="article-video-icon" *ngIf="listItem.type==='article_vs_video'">play_circle_outline</mat-icon>
    <img src="{{listItem.picture_preview}}" class="tile-listing-image tile-listing-image-article" alt="" />
    <mat-icon class="article-link-icon"
              (click)="openStaticPage($event)"
              *ngIf="isTrainerLogin && listItem['itemFullData']['static_html_alias']"
              matTooltip="Open as web page {{listItem['itemFullData']['static_html_alias']}}">link</mat-icon>
    <mat-icon class="article-link-icon"
              (click)="clickStop($event)"
              *ngIf="isTrainerLogin && !listItem['itemFullData']['static_html_alias']"
              color="accent"
              matTooltip="This item has not been exported yet">warning</mat-icon>
  </section>
  <h1 class="tile-header text-center" style="margin-bottom: 0px;">{{listItem.name}}</h1>
  <div style="text-align: center;" (click)="clickStop($event)" *ngIf="!isTrainerLogin">&nbsp;</div>
  <div style="text-align: center;" (click)="clickStop($event)" *ngIf="isTrainerLogin">
    <!--<button mat-icon-button class="article-action-btn" (click)="action($event,'reorder')"-->
            <!--[matTooltip]="'change order'">-->
      <!--<svg width="24px" fill="currentColor" viewBox="0 0 24 24">-->
        <!--<path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>-->
        <!--<path d="M0 0h24v24H0z" fill="none"></path>-->
      <!--</svg>-->
    <!--</button>-->
    <button mat-icon-button class="article-action-btn" (click)="action($event,'clickEdit')">
      <mat-icon class="article-action-icon material-icons-outlined" color="accent" [matTooltip]="'Edit'">edit</mat-icon>
    </button>
    <button mat-icon-button class="article-action-btn" (click)="action($event,'reorder')">
      <mat-icon class="article-action-icon material-icons-outlined" color="accent" [matTooltip]="'Change order'">open_with</mat-icon>
    </button>
    <button mat-icon-button class="article-action-btn" (click)="action($event,'export')">
      <mat-icon class="article-action-icon material-icons-outlined" color="accent" [matTooltip]="'Export to static web page'">open_in_new</mat-icon>
    </button>
    <button mat-icon-button class="article-action-btn" (click)="action($event,'delete')">
      <mat-icon class="article-action-icon material-icons-outlined" color="accent" [matTooltip]="'Delete'">delete</mat-icon>
    </button>
  </div>
</mat-card>

<mat-card
  *ngIf="viewState === 'community_class'"
  [class.subscribe-event-tile]="true"
  [class.is_mouse_over]="isMouseOver" [class.last-child]="(((idx+1) % 3) === 0) ? true : false "
  (mouseover)="isMouseOver=true" (mouseout)="isMouseOver=false">
  <section style="width:100%; margin-top:0px; text-align: center;">
    <img src="{{listItem.picture_preview}}" class="tile-listing-image tile-listing-image-article" alt="" />
    <mat-icon class="article-link-icon" *ngIf="listItem['itemFullData']['payload_parsed']['link']"
              (click)="openCourseShares($event)"
              color="accent">share</mat-icon>
    <mat-icon *ngIf="!hideEditControl && listItem['itemFullData']['profile_id'] == application.user.id"
              class="article-link-icon"
              [class.folder-edit-icon]="listItem['itemFullData']['payload_parsed']['link'] ? true : false"
              (click)="editFolder($event)"
              color="accent">edit</mat-icon>
    <mat-icon *ngIf="listItem['itemFullData']['payload_parsed']['type'] == 'smart_class' && (this.isOwnerLogin || (listItem['itemFullData']['payload_parsed']['admins'] && listItem['itemFullData']['payload_parsed']['admins'].includes(application.user.id)))"
              class="article-link-icon"
              [class.folder-share-icon]="true"
              (click)="assignGroupUsers($event)"
              color="accent">person_add</mat-icon>
  </section>
  <h1 class="tile-header text-center">{{listItem.name}}</h1>
  <section style="width:100%; margin-top:0px; text-align: center;">
    <button mat-raised-button color="accent" style="width: 100%;">{{'more' | GetLabelPipe}}</button>
  </section>
  <div class="tile-hint text-center">{{listItem.size}} {{'members' | GetLabelPipe}}</div>
</mat-card>


